import { gql } from 'apollo-boost';

export const allContacts = gql`
  query contact($orgId: ID!) {
    contact {
      all(orgId: $orgId) {
        id
        email
        firstName
        lastName
        phone
        active
        rowVersion
      }
    }
  }
`;

export const pagedContacts = gql`
  query contact(
    $orgId: ID!
    $limit: Int!
    $offset: Int!
    $includeExpired: Boolean!
  ) {
    contact {
      paged(
        orgId: $orgId
        limit: $limit
        offset: $offset
        includeExpired: $includeExpired
      ) {
        results {
          id
          email
          firstName
          lastName
          phone
          rowVersion
          active
        }
        totalCount
      }
    }
  }
`;
